import { useQueryString } from '@carafe/components';
import {
  SignInSettingsOutput,
  useGetSignInSettingsQuery,
} from '@generated/graphql';

interface UseSocialLoginUrls {
  isFetching: boolean;
  links?: SignInSettingsOutput;
}

export const useSocialLoginUrls = (): UseSocialLoginUrls => {
  const [
    email,
    code,
    returnTo,
    customerCode,
    redirectUri,
    sandboxManagement,
    target,
  ] = useQueryString([
    'email',
    'code',
    'returnTo',
    'customerCode',
    'redirectUri',
    'sandboxManagement',
    'target',
  ]);

  const [{ fetching: isFetching, data: links }] = useGetSignInSettingsQuery({
    variables: {
      authState: {
        returnTo,
        email,
        code,
        customerCode: customerCode ?? '',
        redirectUri,
        origin: window.location.origin,
        sandboxManagement: sandboxManagement?.toLowerCase() === 'true',
        target,
      },
    },
  });

  return { isFetching, links: links?.getSignInSettings };
};
